import { FieldValues, Path, UseFormSetError } from 'react-hook-form'
import { BadRequestError, FieldError } from '../dtos'

export function setModelStateErrors<T extends FieldValues>(
  setError: UseFormSetError<T>,
  response: BadRequestError<T>,
) {
  for (const error of response.fieldErrors as FieldError<T>[]) {
    setError(error.key as Path<T>, { type: 'manual', message: error.messages[0] })
  }
}
